import styled from '../../theme'
import { IWithSize } from '../../containers/BookingCalendar/Calendar/Calendar'

const WrappingText = styled.small<IWithSize>`
  text-wrap: normal;
  font-size: ${({ size }) => (size ? 13.333 * size : 13.333)}px;
`

export default WrappingText
